/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { Row, Col } from 'reactstrap'

import InputNumber from 'rc-input-number';
import CreatableSelect from 'react-select'
import Select from 'react-select'

import {AppContext} from '../../AppContext';

class NumericKeywordValue extends React.Component
{

  inputKeywordValue = undefined;

  componentDidMount()
  {
    if ('dynamic list' === this.props.keywordAndValue.userInputHandling || 'static list' === this.props.keywordAndValue.userInputHandling)
      this.fetchSuggestedValues();
  }

  constructor(props)
  {
    super();

    this.state =
    {
      suggestedValues: [],
      keywordValue: 'integer' === props.keywordAndValue.keywordValueType ? props.keywordAndValue.integerValue : 
        props.keywordAndValue.floatingPointValue,
      validNumber:  true,
      formatMessage: undefined
    }

    this.selectChangeHandler = this.selectChangeHandler.bind(this);
    this.creatableInputChange = this.creatableInputChange.bind(this);
    this.creatableChange = this.creatableChange.bind(this);
    this.setKeywordValue = this.setKeywordValue.bind(this);
  }

  creatableChange(value, actionMetaD)
  {
    if ('select-option' === actionMetaD.action)
    {
      this.setState({keywordValue: value.keywordValue});
      this.props.setKeywordValue(value.keywordValue);      
      return;
    }
  }

  creatableInputChange(value, actionMetaData)
  {
    if ('create-option' === actionMetaData.action)
    {
      this.props.setSaveButtonDisabled(undefined === value ? true : false);
      this.setState({keywordValue: value.keywordValue});
      this.props.setKeywordValue(value.keywordValue);
      return;
    }

    if ('select-option' === actionMetaData.action)
    {
      this.props.setSaveButtonDisabled(undefined === value ? true : false);
      this.setState({keywordValue: value.keywordValue});
      this.props.setKeywordValue(value.keywordValue);      
      return;
    }

    if ('input-change' === actionMetaData.action)
    {
      this.props.setSaveButtonDisabled(undefined === value ? true : false);
      this.inputKeywordValue = value;
      return;
    }

    if ('menu-close' === actionMetaData.action)
    {
      if ('' === value && undefined !== this.inputKeywordValue)
      {
        this.props.setSaveButtonDisabled(false);
        switch (this.props.keywordAndValue.keywordValueType)
        {
          case 'integer':
            if (!window.isAnInteger(this.inputKeywordValue))
            {
              this.setState({validNumber: false, formatMessage: 'Enter a valid integer value.'});
              return;
            }
            break;

          case 'floating point':
            if (!window.isAFloatingPoint(this.inputKeywordValue))
            {
              this.setState({validNumber: false, formatMessage: 'Enter a valid floating point value.'});
              return;
            }
            break;

          default:
            break;
        }

        this.setState({keywordValue: this.inputKeywordValue, validNumber: true});
        this.props.setKeywordValue(this.inputKeywordValue);
        this.inputKeywordValue = undefined;
        return;
      }
    }
  }

  async fetchSuggestedValues()
  {
    let bodyData = {keywordId: this.props.keywordAndValue.keywordId};
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getSuggestions', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error getting suggested keyword values');    
    this.setState({suggestedValues: result.jsonData.suggestedValues});
  }

  isValidNewOption(inputValue, selectValue, selectOptions)
  {
    return false;
  }

  render()
  {
    if ('dynamic list' === this.props.keywordAndValue.userInputHandling)
      return this.renderInputAndSuggested();

    if ('no suggestions' === this.props.keywordAndValue.userInputHandling)
      return this.renderInput();

    if ('static list' === this.props.keywordAndValue.userInputHandling)
      return this.renderSuggested();

    return (<div><p>This keyword is not setup properly to allow user input or offer suggested values.</p></div>);
  }

  renderInputAndSuggested()
  {
    let formFeedback = null;

    if (!this.props.validValue)
      formFeedback = (
        <div style={{color: 'red'}}>
          <Row><Col>You must select or provide a value...!!!</Col></Row>
        </div>
      );

    if (!this.state.validNumber)
      formFeedback = (
        <div style={{color: 'red'}}>
          <Row><Col>{this.state.formatMessage}</Col></Row>
        </div>
      );

    return(
      <div>
        <Row>
          <Col>
            <CreatableSelect id="keywordValue" value={{keywordValue: this.state.keywordValue}} options={this.state.suggestedValues} 
              getOptionLabel={option => option.keywordValue} getOptionValue={option => option.keywordValue}
              autoFocus simpleValue={true} clearValueText="Clear" noResultsText="No suggested values found"
              promptTextCreator={this.selectCreateOptionText} 
              getNewOptionData={(inputValue, optionLabel) => (
                {
                  keywordValue: inputValue
                })}
              isValidNewOption={this.isValidNewOption}
              onChange={this.creatableChange}
              onInputChange={this.creatableInputChange}
            />
          </Col>
        </Row>
        {formFeedback}
      </div>
    );
  }

  renderInput()
  {
    let formFeedback = null;

    if (!this.props.validValue)
      formFeedback = (
        <div style={{color: 'red'}}>
          <Row><Col>You must provide a value...!!!</Col></Row>
        </div>
      );

    let precision = ('floating point' === this.props.keywordAndValue.keywordValueType ? 6 : 0);

    return(
      <div>
        <Row>
          <Col>
            <InputNumber value={this.state.keywordValue} onChange={this.setKeywordValue} 
              placeholder={'Provide a numeric value....'} autoFocus={true} precision={precision}
            />
          </Col>
        </Row>
        {formFeedback}
      </div>
    );
  }

  renderSuggested()
  {
    let formFeedback = null;

    if (!this.props.validValue)
      formFeedback = (
        <div style={{color: 'red'}}>
          <Row><Col>You must select a value...!!!</Col></Row>
        </div>
      );

    return(
      <div>
        <Row>
          <Col>
            <Select value={{keywordValue: this.state.keywordValue}} options={this.state.suggestedValues} 
              getOptionLabel={option => option.keywordValue} getOptionValue={option => option.keywordValue}
              autoFocus={true} simpleValue={true} clearValueText="Clear" noResultsText="No suggested values found"
              onChange={this.selectChangeHandler} placeholder='Select a numeric value...'
            />
          </Col>
        </Row>
        {formFeedback}
      </div>
    );
  }

  selectCreateOptionText(optionValue)
  {
    return 'Create value "' + optionValue + '"';
  }

  selectChangeHandler(value, actionMetaD)
  {
    this.props.setSaveButtonDisabled(undefined === value ? true : false);
    this.setState({keywordValue: value.keywordValue});
    this.props.setKeywordValue(value.keywordValue);
  }

  setKeywordValue(valueAsANumber, valueAsAString, input)
  {
    this.props.setSaveButtonDisabled(undefined === valueAsANumber ? true : false);
    this.setState({keywordValue: valueAsANumber});
    this.props.setKeywordValue(valueAsANumber);
  }
}

NumericKeywordValue.contextType = AppContext;

export default NumericKeywordValue
